import { BasketPoint } from '@/types/api/api-v3/basket-points'
import { NewProduct, NewProductTag } from '@/types/api/api-v4/product'
import { Factoid } from '@/types/main'

import { Position } from 'geojson'

export type LatLng = [lat: number, lng: number, alt?: number]

/* Slug delivery */
export interface TemplatePage {
  area_delivery_time: number
  area_minimal_order: string
  title: string
  marketing_text: string
  seo_text: string
  seo_h1: string
  show_filters: boolean
  products: NewProduct[]
  tags: NewProductTag[]
  categories: TemplateCategories[]
  factoid: Factoid
  seo_title: string
  seo_description: string
  seo_keywords: string
}

export interface TemplateCategories {
  name: string
  slug: string
}

/* Page model */

export interface DeliveryPage {
  title: string
  page_title: string | null
  howto_phone_order: string
  seo: DeliverySeo
  howto_site_order: string
  notice_text: string | null
  factoid_title: string | null
  factoid_text: string | null
  additives: Additives[]
  point_filters: PointFilter[]
  breadcrumbs: Breadcrumb[]
  coordinates: [lat: number, lng: number]
}

export interface DeliverySeo {
  seo_description: string | undefined
  seo_title: string | undefined
  seo_keywords: string | undefined
}

export interface Additives {
  url: string
  description: string
  title: string
}

export interface PointFilter {
  name: string
  slug: string
  enabled: boolean
  show: boolean
}

export interface Breadcrumb {
  text: string
  href: string
}

/* Areas model */

export interface AreasData {
  areas: AreaProperties[]
  points: PointProperties[]
}

export interface AddressSystemAreasData {
  areas: AreaProperties[]
  points: BasketPoint[]
}

export interface AreaProperties {
  id: string | number | undefined
  polygon: number[][][] | Position[][]
  properties: PolygonProperties
}

export interface PointProperties {
  address: string
  cafe: boolean
  cooking_time: number
  coordinates: LatLng
  how_to_find: string
  id: number
  is_open: boolean
  slug: string
  tags: Tag[]
  working_hours: WorkingHours[]
  distance?: number
  city_domain_prefix?: string
  allow_redirect?: boolean
}

export interface WorkingHours {
  start: string
  end: string
  label: string
  is_working: boolean
}

export interface ModifiedWorkingHours extends WorkingHours {
  isCurrent?: boolean
}

export interface PolygonProperties {
  cooking_time: number
  costs: Cost[]
  delivery_time: number
  free_delivery_from: number
  min_price: number
  stroke: string
}

export interface Cost {
  amount_from: number
  amount_to: number
  cost: number
}

export interface Tag {
  name: string
  slug: string
  show: boolean
}

export interface DragCoordinates {
  lower_left: LatLng
  upper_right: LatLng
}

export const TypeAddressSystemAreas = 'address-system'

export type PayloadAddressSystemAreas = typeof TypeAddressSystemAreas

/* Определяем условный тип в зависимости от параметра */
export type AreasDataResponse<T> = T extends PayloadAddressSystemAreas
  ? AddressSystemAreasData
  : AreasData

export type FetchAreasParam = PayloadAddressSystemAreas | undefined
